module.exports = __webpack_public_path__ + "static/media/christmas.e7c4beb4.png";